/**
 * SpineAnimation.ts
 */
export class SpineAnimation {
}
SpineAnimation.DEFAULT = "default";
SpineAnimation.DAB = "dab";
SpineAnimation.DABBED = "dabbed";
SpineAnimation.DOUBLE_DAB = "doubledab";
SpineAnimation.FLASH = "flash";
SpineAnimation.HIGHLIGHT = "highlight";
SpineAnimation.HIGHLIGHT_SUPERWILD = "highlightsuperwild";
SpineAnimation.ALT_HIGHLIGHT = "highlight2";
SpineAnimation.FULL_HOUSE = "fullhouse";
SpineAnimation.BIG_WIN = "bigwin";
SpineAnimation.AVAILABLE_WIN = "availablewin";
SpineAnimation.DEFAULT_ANIMATION = "animation";
SpineAnimation.APPEAR = "appear";
SpineAnimation.DISAPPEAR = "disappear";
SpineAnimation.LAND = "land";
SpineAnimation.READY = "ready";
SpineAnimation.STATIC = "static";
SpineAnimation.HIDE_BIG_WIN = "hideBigWin";
SpineAnimation.SHOW_BIG_WIN = "showBigWin";
SpineAnimation.HIDE_FULL_HOUSE = "hideFullHouse";
SpineAnimation.SHOW_FULL_HOUSE = "showFullHouse";
SpineAnimation.UPDATE_SPINS_REMAINING = "spin";
SpineAnimation.UPDATE_PURCHASE_SPINS_REMAINING = "spinpurchasespin";
//# sourceMappingURL=SpineAnimation.js.map